export enum GatewayPagamento {
  BS2 = 'BS2'
}
